
import {  sendApi } from ".";
import { T_Place } from "../model/placeModel";

async function productList(data?: any) {
    const response = await sendApi({
      method: "post",
      url: "/product/list",
      data: {
        ...data,
      },
    });
    console.log(response)
    return response;
  }

async function productCreate(data1?:T_Place){

  const response = await sendApi({
    method: "post",
    url: "/product/insert",
    data: {
      ...data1,
    },
  });

  
  return response;
}  

async function productDelete(data1?:T_Place){

  const response = await sendApi({
    method: "post",
    url: "/product/delete",
    data: {
      ...data1,
    },
  });

  return response;
}  

async function productUpdate(data1?:T_Place){

  const response = await sendApi({
    method: "post",
    url: "/product/update",
    data: {
      ...data1,
    },
  });

  return response;
}  


async function productInfo(data1?:T_Place){

  const response = await sendApi({
    method: "post",
    url: "/product/info",
    data: {
      ...data1,
    },
  });

  return response;
}  


const product = {
    productList,
    productCreate,
    productDelete,
    productInfo,
    productUpdate
  };
  export default product;

